import { ROOT_SERVER_URL } from '../config';
import { request } from '../utils';
import { setPaginationParams, type PaginationParams } from './pagination';

export type EntitlementsPermissionType = 'data-feeds-lake' | 'data-feeds-aws-arbitrated-pcaps' | 'data-feeds-aws-raw';

export type EntitlementsReportRequest = {
  organizations: string[];
  feedCodes: string[];
  types: EntitlementsPermissionType[];
  startDate: string;
  ongoing: boolean;
};

export type EntitlementsReportRow = {
  id: string;
  name: string;
  feedId: string;
  isActive: boolean;
  isDayEntitlement: boolean;
  expiryDate: string | null;
  startDate: string;
  endDate: string;
  isOngoing: boolean;
  onGoingMaxDate: string;
  feed: { id: string; name: string };
  permission: {
    id: string;
    type: EntitlementsPermissionType;
    group: {
      id: string;
      name: string;
      organization: { id: string; name: string };
    };
  };
  permissionId: string;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
  deletedAt: string;
};

export function getEntitlementsReport(
  params: EntitlementsReportRequest,
  pagination: PaginationParams
): Promise<{ items: EntitlementsReportRow[]; count: number }> {
  const urlSearchParams = getEntitlementsReportSearchParams(params, pagination);

  return request(`${ROOT_SERVER_URL}/api/reports/entitlements?${urlSearchParams}`);
}

export function getEntitlementsReportCsvUrl(params: EntitlementsReportRequest): string {
  const urlSearchParams = getEntitlementsReportSearchParams(params);

  return `${ROOT_SERVER_URL}/api/reports/entitlements/csv?${urlSearchParams}`;
}

export function getEntitlementsReportSearchParams(params: EntitlementsReportRequest, pagination?: PaginationParams) {
  const urlSearchParams = new URLSearchParams();
  params.organizations.forEach((org) => urlSearchParams.append('organizations', org));
  params.types.forEach((type) => urlSearchParams.append('types', type.toString()));
  params.feedCodes.forEach((code) => urlSearchParams.append('feedCodes', code));
  urlSearchParams.append('startDate', params.startDate);
  urlSearchParams.append('ongoing', params.ongoing.toString());

  if (pagination) {
    setPaginationParams(urlSearchParams, pagination);
  }

  return urlSearchParams;
}
